import  smdRepos from './sub-modules/smd/Repositories/index'
import  schoolPrincipal from './sub-modules/school-principal/Repositories/index'


export default {
  ...smdRepos,
  ...schoolPrincipal
}
